import React, { useState } from 'react';

import {
  ModalUnstyledProps,
} from '@mui/material';

import {
  BaseColorKeys, NotifierColorKeys, SubjectColorKeys,
} from '../../theme';
import CollapsableNotification from '../CollapsableNotification';
import Modal from '../Modal';
import SearchField, { DropdownSearchFieldProps } from '../SearchField';

import {
  ActionContainer, Container, SearchContainer,
} from './index.styles';

interface ModalProps extends Omit<ModalUnstyledProps, 'children'>{
  open: boolean,
  handleClose: (event?: object, reason?: string) => void
  hideCloseIcon?: boolean,
  title?: string,
  titleColor?: BaseColorKeys | SubjectColorKeys | NotifierColorKeys,
  description?: string,
  searchPlaceholder?: string,
  searchFieldProps: DropdownSearchFieldProps,
  onAdd: (x: any) => void,
  isError?: boolean,
  error?: string,
  closeNotifs?: () => void,
  isLoading?: boolean,
  isSuccess?: boolean,
}

const AdditionModal = ({
  open = false,
  handleClose = () => {},
  hideCloseIcon = false,
  isError = false,
  error,
  closeNotifs = () => {},
  searchPlaceholder = 'Entries',
  title,
  titleColor = 'primary',
  searchFieldProps = {
    options: [],
    getOptionLabel: (option: any) => option,
    getOptionKey: (option: any) => option,
  },
  onAdd = () => {},
  isLoading = false,
  isSuccess = false,
  ...props
}: ModalProps) => {
  const [entry, setEntry] = useState<any>(null);

  return (
    <Modal
      open={open}
      handleClose={handleClose}
      hideCloseIcon={hideCloseIcon}
      title={title}
      titleColor={titleColor}
      buttons={[
        {
          label: 'Add',
          onClick: () => entry && onAdd(entry),
          color: 'darkPrimary',
          closeOnClick: false,
          loading: isLoading,
          disabled: entry === null,
        },
      ]}
      {...props}
    >
      <Container>
        <CollapsableNotification
          type="error"
          open={isError}
          close={closeNotifs}
          message={error}
        />
        <CollapsableNotification
          type="success"
          open={isSuccess}
          close={closeNotifs}
          message="Added successfully"
        />
        <ActionContainer>
          <SearchContainer>
            <SearchField
              {...searchFieldProps}
              type="dropdown"
              placeholder={`Search ${searchPlaceholder}...`}
              onSelect={(x) => {
                setEntry(x);
                if (searchFieldProps?.onSelect) searchFieldProps.onSelect(x);
              }}
              clearOnSelect
            />
          </SearchContainer>
        </ActionContainer>
      </Container>
    </Modal>
  );
};

export default AdditionModal;
